// Handoff for "Back" from the first Phase 3 LOB page: history.goBack() can't
// carry router state, so LobShell records the Phase 2 page to resume on (the
// coverage page) and the remounted Phase 2 survey applies it once.
//
// Split into peek/clear (not a single consume): the survey reads it during
// render, and StrictMode double-invokes render — removal there would hand the
// kept second pass a null. Callers peek while rendering and clear from an
// effect after the resumed page has committed.
const PHASE2_RESUME_PAGE_KEY = 'phase2ResumePageName';

export const setPhase2ResumePageName = (pageName: string): void => {
  sessionStorage.setItem(PHASE2_RESUME_PAGE_KEY, pageName);
};

export const peekPhase2ResumePageName = (): string | null =>
  sessionStorage.getItem(PHASE2_RESUME_PAGE_KEY);

export const clearPhase2ResumePageName = (): void => {
  sessionStorage.removeItem(PHASE2_RESUME_PAGE_KEY);
};
